module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod",
    staticStyle: {
      "z-index": "9999"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/时间.svg",
      "data-src": "/static/img/时间.svg",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n    短信已发送，等待签署\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "summary"
  }, [_vm._v("\n    请点击短信链接，根据提示在支付宝中完成签署，如果未收到短信，可尝试点击按钮重新发送\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.resendTime !== 0 ? 'bd' : 'submain',
    on: {
      "click": _vm.counter
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("\n      重新发送短信\n      "), (_vm.resendTime !== 0) ? _c('span', [_vm._v("\n        （" + _vm._s(_vm.resendTime) + "）\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "submain",
    on: {
      "click": _vm.checkOrderStatus
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("\n      我已完成签署\n    ")])]), _vm._v(" "), (this.$route.query.canShow) ? _c('div', {
    staticClass: "submain",
    staticStyle: {
      "background": "#FFFFFF",
      "border-radius": "44px",
      "border": "1px solid #5878FA"
    },
    on: {
      "click": _vm.returnAuthenticationHome
    }
  }, [_c('span', {
    staticClass: "tag",
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("\n      返回修改信息\n    ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01fcba10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Authentication/sendAuthentication.vue
// module id = 1521
// module chunks = 8